module.exports = __webpack_public_path__ + "static/media/devkund.3e4a1df8.jpg";